import React from 'react';
import { Helmet } from 'react-helmet-async';
import PortalAccessReady from './PortalAccessReady';

export default function PaymentProcessingPage() {
  return (
    <>
      <PortalAccessReady />
      <Helmet>
        <script>
          fbq('track', 'Lead');
        </script>
      </Helmet>
    </>
  );
}
